import { AuthLayout } from '../ui/AuthLayout.js'

/**
 * Says what happened and offers no navigation, because the only pages reachable
 * so far are public ones arrived at from a link in an email.
 */
export function NotFoundPage() {
  return (
    <AuthLayout>
      <div className="text-center">
        <h1 className="mb-2.5 font-bold text-[24px] text-t1">That page does not exist</h1>
        <p className="text-[14px] text-t2">
          The link may have expired, or part of it may have been cut off when it was copied.
        </p>
      </div>
    </AuthLayout>
  )
}
